













































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  LinkedAccountApi,
  BankAccountDefaultsRequest,
  LinkedAccountState
} from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

const accountTitle = (account: LinkedAccountApi) => account
  ? (account.bankAccountName ? account.bankAccountName : account.linkedBankAccountType + ` (` + account.bankAccountNumber + ` )` )
  : "";
const areSame = (a: LinkedAccountApi, b: LinkedAccountApi) => {
  if (!a || !b) {
    return !a && !b;
  }

  return a.linkedBankAccountId === b.linkedBankAccountId;
};

@Component({
  components: {
    Button
  }
})
export default class LinkedAccountDefaults extends Vue {
  defaultContributionAccountEdit: null | LinkedAccountApi = null;
  defaultReimbursementAccountEdit: null | LinkedAccountApi = null;
  bankAccountStore = useBankAccountStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  disabled: boolean;

  get hasMultipleAccounts (): boolean {
    return this.bankAccountStore.verifiedLinkedAccounts.length > 1 && this.bankAccountStore.linkedAccountState !==
      LinkedAccountState.Loading;
  }

  get selectedContributionAccount () {
    return this.defaultContributionAccountEdit || this.bankAccountStore.defaultContributionAccount || null;
  }

  set selectedContributionAccount (value: any) {
    if (!value) {
      return;
    }

    this.defaultContributionAccountEdit = areSame(value, this.bankAccountStore.defaultContributionAccount)
      ? null
      : value;
  }

  get selectedReimbursementAccount () {
    return this.defaultReimbursementAccountEdit || this.bankAccountStore.defaultReimbursementAccount || null;
  }

  set selectedReimbursementAccount (value: any) {
    if (!value) {
      return;
    }

    this.defaultReimbursementAccountEdit = areSame(value, this.bankAccountStore.defaultReimbursementAccount)
      ? null
      : value;
  }

  get isChangeToDefaults (): boolean {
    return !!this.defaultContributionAccountEdit || !!this.defaultReimbursementAccountEdit;
  }

  mounted () {
    this.resetEdits();
  }

  @Watch("bankAccountStore.linkedAccountState")
  onLinkedAccountStateChanged () {
    this.resetEdits();
  }

  otherLinkedAccounts (toRemove: LinkedAccountApi): LinkedAccountApi[] {
    const i = this.bankAccountStore.verifiedLinkedAccounts.findIndex(a => areSame(a, toRemove));
    if (i < 0) {
      return this.bankAccountStore.verifiedLinkedAccounts;
    }

    return [
      ...this.bankAccountStore.verifiedLinkedAccounts.slice(0, i),
      ...this.bankAccountStore.verifiedLinkedAccounts.slice(i + 1)
    ];
  }

  accountTitle (account: LinkedAccountApi) {
    return accountTitle(account);
  }

  resetEdits () {
    this.defaultContributionAccountEdit = null;
    this.defaultReimbursementAccountEdit = null;
  }

  onUpdateClicked () {
    if (!this.isChangeToDefaults) {
      return;
    }

    const payload: BankAccountDefaultsRequest = {
      defaultContributionAccountId: this.defaultContributionAccountEdit
        ? this.defaultContributionAccountEdit.linkedBankAccountId
        : null,

      defaultReimbursementAccountId: this.defaultReimbursementAccountEdit
        ? this.defaultReimbursementAccountEdit.linkedBankAccountId
        : null,

      defaultScheduledContributionAccountId: null,
      hasDirectDepositAccount: false,
      isPendingAccount: false,
      hasMissingUses: false
    };

    this.bankAccountStore.updateDefaultAccounts(payload);
  }
}
